import { render } from "./BackGround.vue?vue&type=template&id=37f72d8a&scoped=true"
import script from "./BackGround.vue?vue&type=script&lang=js"
export * from "./BackGround.vue?vue&type=script&lang=js"

import "./BackGround.vue?vue&type=style&index=0&id=37f72d8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f72d8a"]])

export default __exports__